import React, {useState} from "react"
import PropTypes from "prop-types"

import {
  TitleSection,
  ListItemTransaction,
  List,
  FieldDate,
  Pagination,
  ProductSelect,
  TransactionTypeSelect,
  DownloadButton,
  SearchField
} from "~/components/"
import {useApi, useDebounce} from "~/hooks/"
import {withUserFeedback} from "~/helpers/"
import {useTranslation} from "react-i18next"

const TransactionsView = () => {
  const {t} = useTranslation()
  const [params, setParams] = useState({
    start_transaction_date: null,
    end_transaction_date: null,
    "search[query]": "",
    page: 0,
    product_ids: []
  })
  const paramsQueryString = new URLSearchParams(params).toString()

  const setPage = page => setParams({...params, page})
  const setStartTransactionDate = date =>
    setParams({...params, "search[start_transaction_date]": date, page: 0})
  const setEndTransactionDate = date =>
    setParams({...params, "search[end_transaction_date]": date, page: 0})
  const setProductIds = product_ids =>
    setParams({...params, "search[product_ids]": product_ids, page: 0})
  const setTransactionType = type =>
    setParams({...params, "search[type]": type, page: 0})

  const [query, setQuery] = useState("")
  useDebounce(query, 1000, () => {
    setParams({
      ...params,
      "search[query]": query,
      page: 0
    })
  })

  const data = useApi("/transaction_history", {
    params,
    headers: {
      Accept: "application/vnd.shelf.v2"
    }
  })
  const transactions = data && data.items
  const totalPages = data && data.total_pages

  const downloadOptions = [
    {
      name: t("transactions.recentHistory"),
      id: "recent_history",
      filename: "transactions_recent_history"
    }
  ]

  const transaction_reports_data = useApi("/transaction_reports", {
    headers: {
      Accept: "application/vnd.shelf.v2"
    }
  })
  if (transaction_reports_data) {
    downloadOptions.push(
      ...transaction_reports_data.items.map(report => ({
        name: report.year,
        id: report.year,
        filename: report.filename
      }))
    )
  }
  const downloadOptionsWithSuffix = suffix =>
    downloadOptions.map(downloadOption => ({
      ...downloadOption,
      filename: downloadOption.filename + suffix
    }))

  return (
    <React.Fragment>
      <TitleSection>
        <h3>{t("transactions.title")}</h3>
      </TitleSection>
      <div className="sh-searchable-list">
        <div className="searchbar" style={{alignItems: "flex-end"}}>
          <SearchField
            onChange={setQuery}
            placeholder={t("transactions.searchPlaceholder")}
          />
          <FieldDate
            label={t("transactions.fromDate")}
            onChange={setStartTransactionDate}
            name="from"
          />
          <FieldDate
            label={t("transactions.toDate")}
            onChange={setEndTransactionDate}
            name="to"
          />
          <ProductSelect setProductIds={setProductIds} />
          <TransactionTypeSelect setTransactionType={setTransactionType} />
          <div style={{flex: 1}} />
          <DownloadButton
            label={t("transactions.downloadButton", {format: "(.xlsx)"})}
            endpoint={`/transaction_history.xlsx?${paramsQueryString}`}
            filename="filtered_transactions.xlsx"
            mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            automaticRetry
            key={JSON.stringify(params) + "xlsx"}
          />
          <DownloadButton
            label={t("transactions.downloadButton", {format: "(.csv)"})}
            endpoint={`/transaction_history.csv?${paramsQueryString}`}
            filename="filtered_transactions.csv"
            mimeType="text/csv"
            automaticRetry
            key={JSON.stringify(params) + "csv"}
          />
        </div>
        <div className="results">
          {withUserFeedback(
            () => (
              <React.Fragment>
                <List items={transactions} itemRenderer={ListItemTransaction}>
                  <p>{t("transactions.noSearchResults")}</p>
                </List>
                <Pagination
                  currentPage={params.page}
                  totalPages={totalPages}
                  onPageChange={setPage}
                />
              </React.Fragment>
            ),
            [data]
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

TransactionsView.propTypes = {
  update: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired
}

export default TransactionsView



// WEBPACK FOOTER //
// ./src/views/TransactionsView.js